import { Button, ButtonFill, Icon, IconName, Inline } from "@seneca/senekit";

type Props = {
  iconName: IconName;
  onClick: () => void;
  providerDisplayName: string;
  loading?: boolean;
  disabled?: boolean;
  fill?: ButtonFill;
};

export default function SSOButton({
  iconName,
  providerDisplayName,
  loading,
  disabled,
  fill = "outlined",
  onClick
}: Props) {
  return (
    <Button
      onClick={onClick}
      fill={fill}
      width="100%"
      loading={loading}
      disabled={disabled}
    >
      <Inline space="large" alignItems="center" flexWrap="nowrap">
        <Icon iconName={iconName} accessibilityLabel={null} />
        {`Continue with ${providerDisplayName}`}
      </Inline>
    </Button>
  );
}
